export default class FloatingButton {
    constructor(node) {
        this.node = node

        // Scroll offset in pixels after which the button should appear
        this.scrollOffset = 200
        // Estimated footer offset in pixels from which the button should disappear
        this.footerHeightOffset = 300

        // Bind 'this' context for the scrollButtonBehaviour method
        this.scrollButtonBehaviour = this.scrollButtonBehaviour.bind(this)

        this.init()
    }

    init() {
        // console.debug(' -> Floating button init')
        this.addListeners()
    }

    addListeners() {
        window.addEventListener('scroll', this.scrollButtonBehaviour)
        // Execute the scroll behavior immediately to set the initial visibility state
        this.scrollButtonBehaviour()
    }

    scrollButtonBehaviour() {
        const currentScrollPos = window.scrollY
        const windowHeight = window.innerHeight
        const bodyHeight = document.body.offsetHeight

        // The scroll point from which the button should start to disappear
        // (total page height - window height - footer offset)
        const scrollBottomTrigger = bodyHeight - windowHeight - this.footerHeightOffset

        // Determine if the button should be visible
        const shouldBeVisible = currentScrollPos > this.scrollOffset && currentScrollPos < scrollBottomTrigger

        if( shouldBeVisible ){
            if( this.node.classList.contains('is-hidden') ){
                this.node.style.display = 'block';

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.node.classList.remove('is-hidden')
                    })
                })
            }
        } else {
            if( !this.node.classList.contains('is-hidden') ){
                this.node.classList.add('is-hidden')
                this.node.addEventListener('transitionend', (event) => {
                    // Make sure the transition is on the element itself, not a child
                    if( event.target === this.node ){
                        this.hideNodeAfterTransition()
                    }
                }, { once: true })
            }
        }
    }

    // Callback to hide the node completely after the CSS transition
    hideNodeAfterTransition() {
        if( this.node.classList.contains('is-hidden') ){
            this.node.style.display = 'none'
        }
    }

    static reset() {
        // console.debug('  -> Floating button reset')
        FloatingButton.init()
    }

    static init() {
        // console.debug('== Floating button component ==');
        const buttonElement = document.querySelector('.floating-button')
        if( buttonElement ){
            FloatingButton.item = new FloatingButton(buttonElement)
        }
    }
}
